import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

import type { Company } from '../../types';

export const getCompanyListAPI = () => {
  return axiosInstance.get(`${API.PRIMARY}/user/$companylist`);
};

export type CompanyListResponse = Company[];

export const fetchCompanyList = async (): Promise<CompanyListResponse> => {
  const response: AxiosResponse<CompanyListResponse> = await getCompanyListAPI();
  return response.data;
};
